var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6862 1.31248C14.8221 1.4483 14.8681 1.64991 14.8046 1.8312L10.3713 14.4979C10.3036 14.6914 10.1246 14.8239 9.91973 14.8323C9.71489 14.8406 9.52571 14.7231 9.44245 14.5358L6.98722 9.0115L1.46295 6.55627C1.27561 6.47301 1.15808 6.28382 1.16643 6.07898C1.17479 5.87414 1.30734 5.69516 1.50084 5.62743L14.1675 1.1941C14.3488 1.13065 14.5504 1.17666 14.6862 1.31248ZM3.02156 6.15467L7.56909 8.17579C7.6822 8.22606 7.77265 8.31651 7.82292 8.42963L9.84405 12.9772L13.5177 2.48101L3.02156 6.15467Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6874 1.31246C14.8827 1.50772 14.8827 1.82431 14.6874 2.01957L7.72074 8.98624C7.52548 9.1815 7.2089 9.1815 7.01363 8.98624C6.81837 8.79097 6.81837 8.47439 7.01363 8.27913L13.9803 1.31246C14.1756 1.1172 14.4921 1.1172 14.6874 1.31246Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChat);
export default __webpack_public_path__ + "static/media/send-chat.3220af58f9c8718cac35cb8f40033c0e.svg";
export { ForwardRef as ReactComponent };